import { postRequest} from '../libs/AxiosService.util';


export async function serviceGetNotification(params) {
    return await postRequest('notifications', params);
}
export async function serviceGetHomeNotification(params) {
    return await postRequest('home/notifications', params);
}
